import {Inject, Injectable, NgZone} from '@angular/core';
import {FirebaseApp, FirebaseAppConfig} from '@angular/fire';
import {_firebaseAppFactory} from '@angular/fire/firebase.app.module';

import {AOFirebaseConnectionService} from './ao-firebase-connection.service';
import {AOEnvService} from './ao-env.service';

@Injectable({
  providedIn: 'root'
})
export class AOFirebaseFactoryService {

  private connections: { [key: string]: AOFirebaseConnectionService } = {};

  constructor(
    private _app: FirebaseApp,
    private _zone: NgZone,
    @Inject(AOEnvService) private _environment
  ) {
    this.factory(this._environment.firebase.name, this._environment.firebase.configs, this._app);
  }

  conn(name?: string) {
    if (this.connections[name]) {
      return this.connections[name];
    }
    throw new Error('FirebaseApp(' + name + ') not found.');
  }

  makeHash(configs: FirebaseAppConfig): string {
    return JSON.stringify({
      projectId: configs.projectId,
      apiKey: configs.apiKey
    });
  }

  async factory(name: string, configs?: FirebaseAppConfig, app?: FirebaseApp): Promise<boolean> {
    const hash = this.makeHash(configs);

    if (this.connections[name]) {
      if (this.connections[name].hash() === hash) {
        return Promise.resolve(true);
      } else {
        await this.connections[name].destroy();
      }
    }

    if (!app) {
      app = _firebaseAppFactory(configs as FirebaseAppConfig, this._zone, name);
    }

    this.connections[name] = new AOFirebaseConnectionService(name, hash, app, this._zone);

    return Promise.resolve(true);
  }

  async destroy(only: string[] = [], except: string[] = ['master']): Promise<boolean> {
    if (only.length === 0) {
      only = Object.keys(this.connections);
    }

    const promises: Promise<boolean>[] = [];

    Object.keys(this.connections).forEach(name => {
      if (only.indexOf(name) >= 0 && except.indexOf(name) === -1) {
        promises.push(this.conn(name).destroy());
      }
    });

    return Promise.all(promises).then(() => true);
  }

}
